module.exports = __webpack_public_path__ + "static/media/FREEDOM60-BW-vector.112439ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FREEDOM60-BW-vector.png
// module id = 245
// module chunks = 0